import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { useNavScroll } from '@hooks/useNavScroll';
import { ROUTES } from '@constants/index';
import { scrollToAnchor } from '@utils/scroll';

export default function FloatingCTA() {
  const isScrolled = useNavScroll(300);
  const { pathname } = useLocation();

  // The portal has its own conversion target; pointing at the home page's
  // interest form from there would scroll to a section that isn't mounted.
  const isPortal = pathname === ROUTES.INVESTOR_PORTAL;
  const target = isPortal ? '#portal-enquiry' : '#interest';
  const label = isPortal ? 'Start a Conversation' : 'Express Interest';

  return (
    <motion.button
      onClick={() => scrollToAnchor(target)}
      initial={{ opacity: 0, y: 16 }}
      animate={isScrolled ? { opacity: 1, y: 0 } : { opacity: 0, y: 16, pointerEvents: 'none' }}
      transition={{ duration: 0.4 }}
      className="fixed bottom-8 right-8 z-[90] font-sans text-label tracking-nav uppercase bg-accent text-bg-primary px-7 py-3.5 shadow-cta hover:shadow-cta-hover transition-shadow duration-300"
      aria-label={isPortal ? 'Start a conversation with Radiance Financial' : 'Express interest in Radiance Financial'}
    >
      {label}
    </motion.button>
  );
}
